/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RasterDto } from '../../models/raster-dto';

export interface UpdateRaster$Params {
  id: string;
      body: RasterDto
}

export function updateRaster(http: HttpClient, rootUrl: string, params: UpdateRaster$Params, context?: HttpContext): Observable<StrictHttpResponse<RasterDto>> {
  const rb = new RequestBuilder(rootUrl, updateRaster.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RasterDto>;
    })
  );
}

updateRaster.PATH = '/v1/raster/{id}';
